// extracted by css-extract-rspack-plugin
export default {"ownerContainer":"_bace8314","ownerLink":"_2745a873","ownerBalance":"_9106a1f5","noWrap":"_e525f867","yourBidText":"_16ff8551"};